import React from "react";
import icon from "../../assets/check.png";

const steps = [
  { title: "Personal Info", description: "Additional details" },
  { title: "Bank Info", description: "Linked bank accounts" },
  { title: "Confirmation", description: "Withholding forms" },
];
const ProgressSteps = ({ currentStep }) => {
  return (
    <div className="progress-steps-container">
      {steps.map((label, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;

        return (
          <div
            key={stepNumber}
            className={`step ${isCompleted ? "completed" : ""} ${
              isActive ? "active" : ""
            }`}
          >
            <div className="circle">
              {isCompleted ? (
                <img src={icon} alt="Done" style={{ width: "25px", height: "25px" }} />
              ) : (
                <div className="stpNumber">{stepNumber}</div>
              )}
            </div>
            <div className="label">
            <div style={{fontSize:"14px"}}>{label.title}</div>
            <div style={{fontSize:"14px", color:"#5D5D5D"}}>{label.description}</div>
            </div>
            {stepNumber < steps.length && <div className="line" />}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressSteps;



